import { useQuery } from "react-query";
import { useAxios } from "./useAxios";
import {
  ORGANISATION_CATEGORY_URL,
  ORGANISATION_CATEGORY_TYPE_URL,
} from "../api/urls";

export const useCategories = () => {
  const axios = useAxios();

  return useQuery(["categories"], async () => {
    const {
      data: { returned_resultset },
    } = await axios.get(`${ORGANISATION_CATEGORY_URL}`);
    return returned_resultset;
  });
};
export const useCategoryTypes = () => {
  const axios = useAxios();
  return useQuery(["categorytypes"], async () => {
    const {
      data: { returned_resultset },
    } = await axios.get(`${ORGANISATION_CATEGORY_TYPE_URL}`);
    return returned_resultset;
  });
};
